<template>
    <v-container class="toggle animated" v-show="show == null" fluid>
        <v-row v-if="programData.length == 0" class="fill-height">
            <v-col class="d-flex justify-center mt-16">
                <v-card align="center" class="mt-16" elevation="0">
                    <v-icon size="200">
                        mdi-note-alert
                    </v-icon>
                    <v-card-text class="text-button">
                        No Active Programs Found.
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col v-for="program in programData" :key="program.id" cols="12" xl="4" md="4">
                <v-card @click="showCompliance(program)" class="pa-2 d-flex flex-column fill-height" elevation="3">
                    <v-card-text>
                        <div class="text-h6 font-weight-black">{{ program.abbrev }}</div>
                        <div class="text-caption text-grey">{{ program.name }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    <v-container fluid class="toggle animated" v-show="show !== null">
        <div class="d-flex flex-column flex-md-row justify-start align-left justify-md-space-between align-md-center mb-4 ga-2">
            <v-btn
                prepend-icon="mdi-chevron-left"
                @click="show = null"
                class="rounded-lg"
                color="grey-darken-1"
                height="40px"
                elevation="2">
                    Back
            </v-btn>
            <div class="font-weight-bold text-h6">
                {{ title }}
            </div>
        </div>
        <ProgramOutcomesDetails ref="ProgramOutcomesDetails"/>
    </v-container>
</template>

<script>
import { defineComponent } from 'vue';
import ProgramOutcomesDetails from '../Sub-Parent/ProgramOutcomesDetails.vue';

export default defineComponent({
    components: {
        ProgramOutcomesDetails
    },
    data(){
        return {
            show: null,
            title: null,
            loading: false,
            programData: []
        }
    },
    methods: {
        async init(){
            this.loading = true
            let res = await this.axiosCall('/programs/findAllProgramByInstitute/' + this.$store.state.user.office.id, 'get', null, true)
            if(res.data){
                this.loading = false
                this.programData = res.data
            }
        },
        showCompliance(data){
            this.show = data
            this.title = data.abbrev + ' - Program Outcomes'
            this.$refs.ProgramOutcomesDetails.initData(data)
        },
    },
    mounted(){
        this.init()
    },
})
</script>

<style scoped>

</style>